import React from 'react';
import { Link } from 'react-router-dom';

const CTABlock = ({ 
  title = "Start vandaag gratis", 
  description = "Doe de CV-scan en zie direct voorbeeldfeedback.", 
  buttonText = "Gratis CV-scan", 
  buttonLink = "/tools/cv-scan",
  className = "" 
}) => {
  return (
    <div className={`bg-blue-600 rounded-xl p-8 text-center ${className}`}>
      <h2 className="text-2xl font-bold text-white mb-4">{title}</h2>
      <p className="text-blue-100 mb-6 max-w-2xl mx-auto">{description}</p>
      <Link
        to={buttonLink}
        className="inline-block bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
      >
        {buttonText}
      </Link>
    </div>
  );
};

export default CTABlock;